export enum National {
	GH = 'GH',
	GA = 'GA',
	GY = 'GY',
	GM = 'GM',
	GG = 'GG',
	GP = 'GP',
	GT = 'GT',
	GU = 'GU',
	GD = 'GD',
	GE = 'GE',
	GR = 'GR',
	GL = 'GL',
	GW = 'GW',
	GN = 'GN',
	CV = 'CV',
	NA = 'NA',
	NR = 'NR',
	NG = 'NG',
	AQ = 'AQ',
	SS = 'SS',
	ZA = 'ZA',
	NL = 'NL',
	AN = 'AN',
	NP = 'NP',
	NO = 'NO',
	NF = 'NF',
	NC = 'NC',
	NZ = 'NZ',
	NU = 'NU',
	NE = 'NE',
	NI = 'NI',
	TW = 'TW',
	KR = 'KR',
	DK = 'DK',
	DM = 'DM',
	DO = 'DO',
	DE = 'DE',
	TL = 'TL',
	LA = 'LA',
	LR = 'LR',
	LV = 'LV',
	RU = 'RU',
	LB = 'LB',
	LS = 'LS',
	RO = 'RO',
	LU = 'LU',
	RW = 'RW',
	LY = 'LY',
	RE = 'RE',
	LT = 'LT',
	LI = 'LI',
	MG = 'MG',
	MH = 'MH',
	YT = 'YT',
	FM = 'FM',
	MO = 'MO',
	MK = 'MK',
	MW = 'MW',
	MY = 'MY',
	ML = 'ML',
	MQ = 'MQ',
	IM = 'IM',
	MX = 'MX',
	MC = 'MC',
	MA = 'MA',
	MU = 'MU',
	MR = 'MR',
	MZ = 'MZ',
	ME = 'ME',
	MS = 'MS',
	MD = 'MD',
	MV = 'MV',
	MT = 'MT',
	MN = 'MN',
	US = 'US',
	UM = 'UM',
	VI = 'VI',
	AS = 'AS',
	MM = 'MM',
	VU = 'VU',
	BH = 'BH',
	BB = 'BB',
	VA = 'VA',
	BS = 'BS',
	BD = 'BD',
	BM = 'BM',
	VE = 'VE',
	BJ = 'BJ',
	VN = 'VN',
	BE = 'BE',
	BY = 'BY',
	BZ = 'BZ',
	BQ = 'BQ',
	BA = 'BA',
	BW = 'BW',
	BO = 'BO',
	BI = 'BI',
	BF = 'BF',
	BV = 'BV',
	BT = 'BT',
	MP = 'MP',
	KP = 'KP',
	BG = 'BG',
	BR = 'BR',
	BN = 'BN',
	WS = 'WS',
	SA = 'SA',
	GS = 'GS',
	CY = 'CY',
	SM = 'SM',
	ST = 'ST',
	MF = 'MF',
	BL = 'BL',
	EH = 'EH',
	SN = 'SN',
	RS = 'RS',
	LC = 'LC',
	VC = 'VC',
	KN = 'KN',
	PM = 'PM',
	SH = 'SH',
	SO = 'SO',
	SB = 'SB',
	SD = 'SD',
	SR = 'SR',
	SC = 'SC',
	LK = 'LK',
	SJ = 'SJ',
	SZ = 'SZ',
	SE = 'SE',
	CH = 'CH',
	ES = 'ES',
	SK = 'SK',
	SI = 'SI',
	SY = 'SY',
	SL = 'SL',
	SX = 'SX',
	SG = 'SG',
	AE = 'AE',
	AW = 'AW',
	AM = 'AM',
	AR = 'AR',
	IS = 'IS',
	IE = 'IE',
	AZ = 'AZ',
	AF = 'AF',
	AI = 'AI',
	AD = 'AD',
	AL = 'AL',
	DZ = 'DZ',
	AO = 'AO',
	AG = 'AG',
	ER = 'ER',
	EE = 'EE',
	EC = 'EC',
	SV = 'SV',
	GB = 'GB',
	VG = 'VG',
	IO = 'IO',
	YE = 'YE',
	OM = 'OM',
	AU = 'AU',
	AT = 'AT',
	HN = 'HN',
	AX = 'AX',
	JO = 'JO',
	UG = 'UG',
	UY = 'UY',
	UZ = 'UZ',
	UA = 'UA',
	WF = 'WF',
	ET = 'ET',
	IQ = 'IQ',
	IR = 'IR',
	IL = 'IL',
	EG = 'EG',
	IT = 'IT',
	IN = 'IN',
	ID = 'ID',
	JP = 'JP',
	JM = 'JM',
	ZM = 'ZM',
	JE = 'JE',
	GQ = 'GQ',
	CN = 'CN',
	CF = 'CF',
	DJ = 'DJ',
	GI = 'GI',
	ZW = 'ZW',
	TD = 'TD',
	CZ = 'CZ',
	CL = 'CL',
	CM = 'CM',
	KZ = 'KZ',
	QA = 'QA',
	KH = 'KH',
	CA = 'CA',
	KE = 'KE',
	KY = 'KY',
	KM = 'KM',
	CR = 'CR',
	CC = 'CC',
	CI = 'CI',
	CO = 'CO',
	CG = 'CG',
	CD = 'CD',
	CU = 'CU',
	KW = 'KW',
	CK = 'CK',
	CW = 'CW',
	HR = 'HR',
	CX = 'CX',
	KG = 'KG',
	KI = 'KI',
	TJ = 'TJ',
	TZ = 'TZ',
	TH = 'TH',
	TC = 'TC',
	TR = 'TR',
	TG = 'TG',
	TK = 'TK',
	TO = 'TO',
	TM = 'TM',
	TV = 'TV',
	TN = 'TN',
	TT = 'TT',
	PA = 'PA',
	PY = 'PY',
	PK = 'PK',
	PG = 'PG',
	PW = 'PW',
	PS = 'PS',
	FO = 'FO',
	PE = 'PE',
	PT = 'PT',
	FK = 'FK',
	PL = 'PL',
	PR = 'PR',
	FR = 'FR',
	TF = 'TF',
	GF = 'GF',
	PF = 'PF',
	FJ = 'FJ',
	FI = 'FI',
	PH = 'PH',
	PN = 'PN',
	HT = 'HT',
	HM = 'HM',
	HU = 'HU',
	HK = 'HK',
}

export const NATIONAL_LIST = [
	{
		id: National.GH,
		value: National.GH,
		label: '가나',
	},
	{
		id: National.GA,
		value: National.GA,
		label: '가봉',
	},
	{
		id: National.GY,
		value: National.GY,
		label: '가이아나',
	},
	{
		id: National.GM,
		value: National.GM,
		label: '감비아',
	},
	{
		id: National.GG,
		value: National.GG,
		label: '건지',
	},
	{
		id: National.GP,
		value: National.GP,
		label: '과달로프',
	},
	{
		id: National.GT,
		value: National.GT,
		label: '과테말라',
	},
	{
		id: National.GU,
		value: National.GU,
		label: '괌',
	},
	{
		id: National.GD,
		value: National.GD,
		label: '그레나다',
	},
	{
		id: National.GE,
		value: National.GE,
		label: '그루지야',
	},
	{
		id: National.GR,
		value: National.GR,
		label: '그리스',
	},
	{
		id: National.GL,
		value: National.GL,
		label: '그린랜드',
	},
	{
		id: National.GW,
		value: National.GW,
		label: '기네비쏘',
	},
	{
		id: National.GN,
		value: National.GN,
		label: '기니',
	},
	{
		id: National.CV,
		value: National.CV,
		label: '까뽀베르데',
	},
	{
		id: National.NA,
		value: National.NA,
		label: '나미비아',
	},
	{
		id: National.NR,
		value: National.NR,
		label: '나우루',
	},
	{
		id: National.NG,
		value: National.NG,
		label: '나이지리아',
	},
	{
		id: National.AQ,
		value: National.AQ,
		label: '남극',
	},
	{
		id: National.SS,
		value: National.SS,
		label: '남수단',
	},
	{
		id: National.ZA,
		value: National.ZA,
		label: '남아프리카',
	},
	{
		id: National.NL,
		value: National.NL,
		label: '네덜란드',
	},
	{
		id: National.AN,
		value: National.AN,
		label: '네덜란드령 안틸레스',
	},
	{
		id: National.NP,
		value: National.NP,
		label: '네팔',
	},
	{
		id: National.NO,
		value: National.NO,
		label: '노르웨이',
	},
	{
		id: National.NF,
		value: National.NF,
		label: '노퍽 섬',
	},
	{
		id: National.NC,
		value: National.NC,
		label: '뉴 칼레도니아',
	},
	{
		id: National.NZ,
		value: National.NZ,
		label: '뉴질랜드',
	},
	{
		id: National.NU,
		value: National.NU,
		label: '니우에',
	},
	{
		id: National.NE,
		value: National.NE,
		label: '니제르',
	},
	{
		id: National.NI,
		value: National.NI,
		label: '니카라과',
	},
	{
		id: National.TW,
		value: National.TW,
		label: '대만',
	},
	{
		id: National.KR,
		value: National.KR,
		label: '대한민국',
	},
	{
		id: National.DK,
		value: National.DK,
		label: '덴마크',
	},
	{
		id: National.DM,
		value: National.DM,
		label: '도미니카',
	},
	{
		id: National.DO,
		value: National.DO,
		label: '도미니카 공화국',
	},
	{
		id: National.DE,
		value: National.DE,
		label: '독일',
	},
	{
		id: National.TL,
		value: National.TL,
		label: '동티모르',
	},
	{
		id: National.LA,
		value: National.LA,
		label: '라오스',
	},
	{
		id: National.LR,
		value: National.LR,
		label: '라이베리아',
	},
	{
		id: National.LV,
		value: National.LV,
		label: '라트비아',
	},
	{
		id: National.RU,
		value: National.RU,
		label: '러시아',
	},
	{
		id: National.LB,
		value: National.LB,
		label: '레바논',
	},
	{
		id: National.LS,
		value: National.LS,
		label: '레소토',
	},
	{
		id: National.RO,
		value: National.RO,
		label: '루마니아',
	},
	{
		id: National.LU,
		value: National.LU,
		label: '루셈부르크',
	},
	{
		id: National.RW,
		value: National.RW,
		label: '르완다',
	},
	{
		id: National.LY,
		value: National.LY,
		label: '리비아',
	},
	{
		id: National.RE,
		value: National.RE,
		label: '리유니언',
	},
	{
		id: National.LT,
		value: National.LT,
		label: '리투아니아',
	},
	{
		id: National.LI,
		value: National.LI,
		label: '리히텐슈타인',
	},
	{
		id: National.MG,
		value: National.MG,
		label: '마다가스카르',
	},
	{
		id: National.MH,
		value: National.MH,
		label: '마셜 제도',
	},
	{
		id: National.YT,
		value: National.YT,
		label: '마요티',
	},
	{
		id: National.FM,
		value: National.FM,
		label: '마이크로네시아',
	},
	{
		id: National.MO,
		value: National.MO,
		label: '마카오',
	},
	{
		id: National.MK,
		value: National.MK,
		label: '마케도니아어',
	},
	{
		id: National.MW,
		value: National.MW,
		label: '말라위',
	},
	{
		id: National.MY,
		value: National.MY,
		label: '말레이지아',
	},
	{
		id: National.ML,
		value: National.ML,
		label: '말리',
	},
	{
		id: National.MQ,
		value: National.MQ,
		label: '말티니크',
	},
	{
		id: National.IM,
		value: National.IM,
		label: '맨 섬',
	},
	{
		id: National.MX,
		value: National.MX,
		label: '멕시코',
	},
	{
		id: National.MC,
		value: National.MC,
		label: '모나코',
	},
	{
		id: National.MA,
		value: National.MA,
		label: '모로코',
	},
	{
		id: National.MU,
		value: National.MU,
		label: '모리셔스',
	},
	{
		id: National.MR,
		value: National.MR,
		label: '모리타니',
	},
	{
		id: National.MZ,
		value: National.MZ,
		label: '모잠비크',
	},
	{
		id: National.ME,
		value: National.ME,
		label: '몬테네그로',
	},
	{
		id: National.MS,
		value: National.MS,
		label: '몬트세라트',
	},
	{
		id: National.MD,
		value: National.MD,
		label: '몰도바',
	},
	{
		id: National.MV,
		value: National.MV,
		label: '몰디브',
	},
	{
		id: National.MT,
		value: National.MT,
		label: '몰타',
	},
	{
		id: National.MN,
		value: National.MN,
		label: '몽골',
	},
	{
		id: National.US,
		value: National.US,
		label: '미국',
	},
	{
		id: National.UM,
		value: National.UM,
		label: '미국령 군도',
	},
	{
		id: National.VI,
		value: National.VI,
		label: '미국령 버진 아일랜드',
	},
	{
		id: National.AS,
		value: National.AS,
		label: '미국령 사모아',
	},
	{
		id: National.MM,
		value: National.MM,
		label: '미얀마',
	},
	{
		id: National.VU,
		value: National.VU,
		label: '바누아투',
	},
	{
		id: National.BH,
		value: National.BH,
		label: '바레인',
	},
	{
		id: National.BB,
		value: National.BB,
		label: '바베이도스',
	},
	{
		id: National.VA,
		value: National.VA,
		label: '바티칸',
	},
	{
		id: National.BS,
		value: National.BS,
		label: '바하마',
	},
	{
		id: National.BD,
		value: National.BD,
		label: '방글라데시',
	},
	{
		id: National.BM,
		value: National.BM,
		label: '버뮤다',
	},
	{
		id: National.VE,
		value: National.VE,
		label: '베네수엘라',
	},
	{
		id: National.BJ,
		value: National.BJ,
		label: '베넹',
	},
	{
		id: National.VN,
		value: National.VN,
		label: '베트남',
	},
	{
		id: National.BE,
		value: National.BE,
		label: '벨기에',
	},
	{
		id: National.BY,
		value: National.BY,
		label: '벨라루스',
	},
	{
		id: National.BZ,
		value: National.BZ,
		label: '벨리즈',
	},
	{
		id: National.BQ,
		value: National.BQ,
		label: '보네르, 신트유스타티우스, 사바 제도',
	},
	{
		id: National.BA,
		value: National.BA,
		label: '보스니아 헤르체고비나',
	},
	{
		id: National.BW,
		value: National.BW,
		label: '보츠와나',
	},
	{
		id: National.BO,
		value: National.BO,
		label: '볼리비아',
	},
	{
		id: National.BI,
		value: National.BI,
		label: '부룬디',
	},
	{
		id: National.BF,
		value: National.BF,
		label: '부르키나파소',
	},
	{
		id: National.BV,
		value: National.BV,
		label: '부베이 섬',
	},
	{
		id: National.BT,
		value: National.BT,
		label: '부탄',
	},
	{
		id: National.MP,
		value: National.MP,
		label: '북마리아나 제도',
	},
	{
		id: National.KP,
		value: National.KP,
		label: '북한',
	},
	{
		id: National.BG,
		value: National.BG,
		label: '불가리아',
	},
	{
		id: National.BR,
		value: National.BR,
		label: '브라질',
	},
	{
		id: National.BN,
		value: National.BN,
		label: '브루나이',
	},
	{
		id: National.WS,
		value: National.WS,
		label: '사모아',
	},
	{
		id: National.SA,
		value: National.SA,
		label: '사우디아라비아',
	},
	{
		id: National.GS,
		value: National.GS,
		label: '사우스 조지아 및 사우스 샌드위치 제도',
	},
	{
		id: National.CY,
		value: National.CY,
		label: '사이프러스',
	},
	{
		id: National.SM,
		value: National.SM,
		label: '산마리노',
	},
	{
		id: National.ST,
		value: National.ST,
		label: '상투메 프린시페',
	},
	{
		id: National.MF,
		value: National.MF,
		label: '생 마르탱',
	},
	{
		id: National.BL,
		value: National.BL,
		label: '생 바르텔레미',
	},
	{
		id: National.EH,
		value: National.EH,
		label: '서사하라',
	},
	{
		id: National.SN,
		value: National.SN,
		label: '세네갈',
	},
	{
		id: National.RS,
		value: National.RS,
		label: '세르비아',
	},
	{
		id: National.LC,
		value: National.LC,
		label: '세인트 루시아',
	},
	{
		id: National.VC,
		value: National.VC,
		label: '세인트 빈센트 그레나딘스',
	},
	{
		id: National.KN,
		value: National.KN,
		label: '세인트 크리스토퍼 니비스',
	},
	{
		id: National.PM,
		value: National.PM,
		label: '세인트 피에르 미켈론',
	},
	{
		id: National.SH,
		value: National.SH,
		label: '세인트 헬레나',
	},
	{
		id: National.SO,
		value: National.SO,
		label: '소말리아',
	},
	{
		id: National.SB,
		value: National.SB,
		label: '솔로몬 제도',
	},
	{
		id: National.SD,
		value: National.SD,
		label: '수단',
	},
	{
		id: National.SR,
		value: National.SR,
		label: '수리남',
	},
	{
		id: National.SC,
		value: National.SC,
		label: '쉐이쉘',
	},
	{
		id: National.LK,
		value: National.LK,
		label: '스리랑카',
	},
	{
		id: National.SJ,
		value: National.SJ,
		label: '스발바르 및 얀마웬',
	},
	{
		id: National.SZ,
		value: National.SZ,
		label: '스와질랜드',
	},
	{
		id: National.SE,
		value: National.SE,
		label: '스웨덴',
	},
	{
		id: National.CH,
		value: National.CH,
		label: '스위스',
	},
	{
		id: National.ES,
		value: National.ES,
		label: '스페인',
	},
	{
		id: National.SK,
		value: National.SK,
		label: '슬로바키아',
	},
	{
		id: National.SI,
		value: National.SI,
		label: '슬로베니아',
	},
	{
		id: National.SY,
		value: National.SY,
		label: '시리아',
	},
	{
		id: National.SL,
		value: National.SL,
		label: '시에라리온',
	},
	{
		id: National.SX,
		value: National.SX,
		label: '신트마르텐(네덜란드령)',
	},
	{
		id: National.SG,
		value: National.SG,
		label: '싱가포르',
	},
	{
		id: National.AE,
		value: National.AE,
		label: '아랍에미리트',
	},
	{
		id: National.AW,
		value: National.AW,
		label: '아루바',
	},
	{
		id: National.AM,
		value: National.AM,
		label: '아르메니아',
	},
	{
		id: National.AR,
		value: National.AR,
		label: '아르헨티나',
	},
	{
		id: National.IS,
		value: National.IS,
		label: '아이슬란드',
	},
	{
		id: National.IE,
		value: National.IE,
		label: '아일랜드',
	},
	{
		id: National.AZ,
		value: National.AZ,
		label: '아제르바이잔',
	},
	{
		id: National.AF,
		value: National.AF,
		label: '아프가니스탄',
	},
	{
		id: National.AI,
		value: National.AI,
		label: '안길라',
	},
	{
		id: National.AD,
		value: National.AD,
		label: '안도라',
	},
	{
		id: National.AL,
		value: National.AL,
		label: '알바니아',
	},
	{
		id: National.DZ,
		value: National.DZ,
		label: '알제리',
	},
	{
		id: National.AO,
		value: National.AO,
		label: '앙골라',
	},
	{
		id: National.AG,
		value: National.AG,
		label: '앤티가 바부다',
	},
	{
		id: National.ER,
		value: National.ER,
		label: '에리트리아',
	},
	{
		id: National.EE,
		value: National.EE,
		label: '에스토니아',
	},
	{
		id: National.EC,
		value: National.EC,
		label: '에쿠아도르',
	},
	{
		id: National.SV,
		value: National.SV,
		label: '엘살바도르',
	},
	{
		id: National.GB,
		value: National.GB,
		label: '영국',
	},
	{
		id: National.VG,
		value: National.VG,
		label: '영국령 버진 아일랜드',
	},
	{
		id: National.IO,
		value: National.IO,
		label: '영인도 제도',
	},
	{
		id: National.YE,
		value: National.YE,
		label: '예멘',
	},
	{
		id: National.OM,
		value: National.OM,
		label: '오만',
	},
	{
		id: National.AU,
		value: National.AU,
		label: '오스트레일리아',
	},
	{
		id: National.AT,
		value: National.AT,
		label: '오스트리아',
	},
	{
		id: National.HN,
		value: National.HN,
		label: '온두라스',
	},
	{
		id: National.AX,
		value: National.AX,
		label: '올란드 제도',
	},
	{
		id: National.JO,
		value: National.JO,
		label: '요르단',
	},
	{
		id: National.UG,
		value: National.UG,
		label: '우간다',
	},
	{
		id: National.UY,
		value: National.UY,
		label: '우루과이',
	},
	{
		id: National.UZ,
		value: National.UZ,
		label: '우즈베키스탄',
	},
	{
		id: National.UA,
		value: National.UA,
		label: '우크라이나',
	},
	{
		id: National.WF,
		value: National.WF,
		label: '윌리스 푸투나',
	},
	{
		id: National.ET,
		value: National.ET,
		label: '이디오피아',
	},
	{
		id: National.IQ,
		value: National.IQ,
		label: '이라크',
	},
	{
		id: National.IR,
		value: National.IR,
		label: '이란',
	},
	{
		id: National.IL,
		value: National.IL,
		label: '이스라엘',
	},
	{
		id: National.EG,
		value: National.EG,
		label: '이집트',
	},
	{
		id: National.IT,
		value: National.IT,
		label: '이탈리아',
	},
	{
		id: National.IN,
		value: National.IN,
		label: '인도',
	},
	{
		id: National.ID,
		value: National.ID,
		label: '인도네시아',
	},
	{
		id: National.JP,
		value: National.JP,
		label: '일본',
	},
	{
		id: National.JM,
		value: National.JM,
		label: '자메이카',
	},
	{
		id: National.ZM,
		value: National.ZM,
		label: '잠비아',
	},
	{
		id: National.JE,
		value: National.JE,
		label: '저지',
	},
	{
		id: National.GQ,
		value: National.GQ,
		label: '적도 기니',
	},
	{
		id: National.CN,
		value: National.CN,
		label: '중국',
	},
	{
		id: National.CF,
		value: National.CF,
		label: '중앙 아프리카',
	},
	{
		id: National.DJ,
		value: National.DJ,
		label: '지부티',
	},
	{
		id: National.GI,
		value: National.GI,
		label: '지브롤터',
	},
	{
		id: National.ZW,
		value: National.ZW,
		label: '짐바브웨',
	},
	{
		id: National.TD,
		value: National.TD,
		label: '차드',
	},
	{
		id: National.CZ,
		value: National.CZ,
		label: '체코',
	},
	{
		id: National.CL,
		value: National.CL,
		label: '칠레',
	},
	{
		id: National.CM,
		value: National.CM,
		label: '카메룬',
	},
	{
		id: National.KZ,
		value: National.KZ,
		label: '카자흐스탄',
	},
	{
		id: National.QA,
		value: National.QA,
		label: '카타르',
	},
	{
		id: National.KH,
		value: National.KH,
		label: '캄보디아',
	},
	{
		id: National.CA,
		value: National.CA,
		label: '캐나다',
	},
	{
		id: National.KE,
		value: National.KE,
		label: '케냐',
	},
	{
		id: National.KY,
		value: National.KY,
		label: '케이마 제도',
	},
	{
		id: National.KM,
		value: National.KM,
		label: '코모르',
	},
	{
		id: National.CR,
		value: National.CR,
		label: '코스타리카',
	},
	{
		id: National.CC,
		value: National.CC,
		label: '코코스 군도',
	},
	{
		id: National.CI,
		value: National.CI,
		label: '코트디부와르',
	},
	{
		id: National.CO,
		value: National.CO,
		label: '콜롯비아',
	},
	{
		id: National.CG,
		value: National.CG,
		label: '콩고',
	},
	{
		id: National.CD,
		value: National.CD,
		label: '콩고 민주 공화국',
	},
	{
		id: National.CU,
		value: National.CU,
		label: '쿠바',
	},
	{
		id: National.KW,
		value: National.KW,
		label: '쿠웨이트',
	},
	{
		id: National.CK,
		value: National.CK,
		label: '쿡 제도',
	},
	{
		id: National.CW,
		value: National.CW,
		label: '퀴라소',
	},
	{
		id: National.HR,
		value: National.HR,
		label: '크로아티아',
	},
	{
		id: National.CX,
		value: National.CX,
		label: '크리스마스 섬',
	},
	{
		id: National.KG,
		value: National.KG,
		label: '키르기스스탄',
	},
	{
		id: National.KI,
		value: National.KI,
		label: '키리바시',
	},
	{
		id: National.TJ,
		value: National.TJ,
		label: '타지키스탄',
	},
	{
		id: National.TZ,
		value: National.TZ,
		label: '탄자니아',
	},
	{
		id: National.TH,
		value: National.TH,
		label: '태국',
	},
	{
		id: National.TC,
		value: National.TC,
		label: '터크스 케이커스 제도',
	},
	{
		id: National.TR,
		value: National.TR,
		label: '터키',
	},
	{
		id: National.TG,
		value: National.TG,
		label: '토고',
	},
	{
		id: National.TK,
		value: National.TK,
		label: '토켈라우',
	},
	{
		id: National.TO,
		value: National.TO,
		label: '통가',
	},
	{
		id: National.TM,
		value: National.TM,
		label: '투르크메니스탄',
	},
	{
		id: National.TV,
		value: National.TV,
		label: '투발루',
	},
	{
		id: National.TN,
		value: National.TN,
		label: '튀니지',
	},
	{
		id: National.TT,
		value: National.TT,
		label: '트리닉드 토바고',
	},
	{
		id: National.PA,
		value: National.PA,
		label: '파나마',
	},
	{
		id: National.PY,
		value: National.PY,
		label: '파라과이',
	},
	{
		id: National.PK,
		value: National.PK,
		label: '파키스탄',
	},
	{
		id: National.PG,
		value: National.PG,
		label: '파푸아뉴기니',
	},
	{
		id: National.PW,
		value: National.PW,
		label: '팔라우',
	},
	{
		id: National.PS,
		value: National.PS,
		label: '팔레스타인',
	},
	{
		id: National.FO,
		value: National.FO,
		label: '페로 제도',
	},
	{
		id: National.PE,
		value: National.PE,
		label: '페루',
	},
	{
		id: National.PT,
		value: National.PT,
		label: '포르투칼',
	},
	{
		id: National.FK,
		value: National.FK,
		label: '포클랜드 제도',
	},
	{
		id: National.PL,
		value: National.PL,
		label: '폴란드',
	},
	{
		id: National.PR,
		value: National.PR,
		label: '푸에르토리코',
	},
	{
		id: National.FR,
		value: National.FR,
		label: '프랑스',
	},
	{
		id: National.TF,
		value: National.TF,
		label: '프랑스 남부 지방',
	},
	{
		id: National.GF,
		value: National.GF,
		label: '프랑스령 기아나',
	},
	{
		id: National.PF,
		value: National.PF,
		label: '프랑스령 폴리네시아',
	},
	{
		id: National.FJ,
		value: National.FJ,
		label: '피지',
	},
	{
		id: National.FI,
		value: National.FI,
		label: '핀란드',
	},
	{
		id: National.PH,
		value: National.PH,
		label: '필리핀',
	},
	{
		id: National.PN,
		value: National.PN,
		label: '핏케언 제도',
	},
	{
		id: National.HT,
		value: National.HT,
		label: '하이티',
	},
	{
		id: National.HM,
		value: National.HM,
		label: '허드 섬 및 맥도널드 제도',
	},
	{
		id: National.HU,
		value: National.HU,
		label: '헝가리',
	},
	{
		id: National.HK,
		value: National.HK,
		label: '홍콩',
	},
];

export const NATIONAL_LIST_WITH_EN = [
	{
		id: National.GH,
		value: National.GH,
		label: '가나',
		labelEnglish: 'Ghana',
	},
	{
		id: National.GA,
		value: National.GA,
		label: '가봉',
		labelEnglish: 'Gabon',
	},
	{
		id: National.GY,
		value: National.GY,
		label: '가이아나',
		labelEnglish: 'Guyana',
	},
	{
		id: National.GM,
		value: National.GM,
		label: '감비아',
		labelEnglish: 'Gambia',
	},
	{
		id: National.GG,
		value: National.GG,
		label: '건지',
		labelEnglish: 'Guernsey',
	},
	{
		id: National.GP,
		value: National.GP,
		label: '과달로프',
		labelEnglish: 'Guadeloupe',
	},
	{
		id: National.GT,
		value: National.GT,
		label: '과테말라',
		labelEnglish: 'Guatemala',
	},
	{
		id: National.GU,
		value: National.GU,
		label: '괌',
		labelEnglish: 'Guam',
	},
	{
		id: National.GD,
		value: National.GD,
		label: '그레나다',
		labelEnglish: 'Grenada',
	},
	{
		id: National.GE,
		value: National.GE,
		label: '그룹지야',
		labelEnglish: 'Georgia',
	},
	{
		id: National.GR,
		value: National.GR,
		label: '그리스',
		labelEnglish: 'Greece',
	},
	{
		id: National.GL,
		value: National.GL,
		label: '그린랜드',
		labelEnglish: 'Greenland',
	},
	{
		id: National.GW,
		value: National.GW,
		label: '기네비쏘',
		labelEnglish: 'Guinea-Bissau',
	},
	{
		id: National.GN,
		value: National.GN,
		label: '기니',
		labelEnglish: 'Guinea',
	},
	{
		id: National.CV,
		value: National.CV,
		label: '까뽀베르데',
		labelEnglish: 'CapeVerde',
	},
	{
		id: National.NA,
		value: National.NA,
		label: '나미비아',
		labelEnglish: 'Namibia',
	},
	{
		id: National.NR,
		value: National.NR,
		label: '나우루',
		labelEnglish: 'Nauru',
	},
	{
		id: National.NG,
		value: National.NG,
		label: '나이지리아',
		labelEnglish: 'Nigeria',
	},
	{
		id: National.AQ,
		value: National.AQ,
		label: '남극',
		labelEnglish: 'Antarctica',
	},
	{
		id: National.SS,
		value: National.SS,
		label: '남수단',
		labelEnglish: 'SouthSudan',
	},
	{
		id: National.ZA,
		value: National.ZA,
		label: '남아프리카',
		labelEnglish: 'SouthAfrica',
	},
	{
		id: National.NL,
		value: National.NL,
		label: '네덜란드',
		labelEnglish: 'Netherlands',
	},
	{
		id: National.AN,
		value: National.AN,
		label: '네덜란드령 안틸레스',
	},
	{
		id: National.NP,
		value: National.NP,
		label: '네팔',
		labelEnglish: 'Nepal',
	},
	{
		id: National.NO,
		value: National.NO,
		label: '노르웨이',
		labelEnglish: 'Norway',
	},
	{
		id: National.NF,
		value: National.NF,
		label: '노퍽 섬',
		labelEnglish: 'NorfolkIsland',
	},
	{
		id: National.NC,
		value: National.NC,
		label: '뉴 칼레도니아',
		labelEnglish: 'NewCaledonia',
	},
	{
		id: National.NZ,
		value: National.NZ,
		label: '뉴질랜드',
		labelEnglish: 'NewZealand',
	},
	{
		id: National.NU,
		value: National.NU,
		label: '니우에',
		labelEnglish: 'Niue',
	},
	{
		id: National.NE,
		value: National.NE,
		label: '니제르',
		labelEnglish: 'Niger',
	},
	{
		id: National.NI,
		value: National.NI,
		label: '니카라과',
		labelEnglish: 'Nicaragua',
	},
	{
		id: National.TW,
		value: National.TW,
		label: '대만',
		labelEnglish: 'Taiwan',
	},
	{
		id: National.KR,
		value: National.KR,
		label: '대한민국',
		labelEnglish: 'SouthKorea',
	},
	{
		id: National.DK,
		value: National.DK,
		label: '덴마크',
		labelEnglish: 'Denmark',
	},
	{
		id: National.DM,
		value: National.DM,
		label: '도미니카',
		labelEnglish: 'Dominica',
	},
	{
		id: National.DO,
		value: National.DO,
		label: '도미니카 공화국',
		labelEnglish: 'DominicanRepublic',
	},
	{
		id: National.DE,
		value: National.DE,
		label: '독일',
		labelEnglish: 'Germany',
	},
	{
		id: National.TL,
		value: National.TL,
		label: '동티모르',
		labelEnglish: 'Timor-Leste',
	},
	{
		id: National.LA,
		value: National.LA,
		label: '라오스',
		labelEnglish: 'Laos',
	},
	{
		id: National.LR,
		value: National.LR,
		label: '라이베리아',
		labelEnglish: 'Liberia',
	},
	{
		id: National.LV,
		value: National.LV,
		label: '라트비아',
		labelEnglish: 'Latvia',
	},
	{
		id: National.RU,
		value: National.RU,
		label: '러시아',
		labelEnglish: 'Russia',
	},
	{
		id: National.LB,
		value: National.LB,
		label: '레바논',
		labelEnglish: 'Lebanon',
	},
	{
		id: National.LS,
		value: National.LS,
		label: '레소토',
		labelEnglish: 'Lesotho',
	},
	{
		id: National.RO,
		value: National.RO,
		label: '루마니아',
		labelEnglish: 'Romania',
	},
	{
		id: National.LU,
		value: National.LU,
		label: '룩셈부르크',
		labelEnglish: 'Luxembourg',
	},
	{
		id: National.RW,
		value: National.RW,
		label: '르완다',
		labelEnglish: 'Rwanda',
	},
	{
		id: National.LY,
		value: National.LY,
		label: '리비아',
		labelEnglish: 'Libya',
	},
	{
		id: National.RE,
		value: National.RE,
		label: '리유니언',
		labelEnglish: 'Réunion',
	},
	{
		id: National.LT,
		value: National.LT,
		label: '리투아니아',
		labelEnglish: 'Lithuania',
	},
	{
		id: National.LI,
		value: National.LI,
		label: '리히텐슈타인',
		labelEnglish: 'Liechtenstein',
	},
	{
		id: National.MG,
		value: National.MG,
		label: '마다가스카르',
		labelEnglish: 'Madagascar',
	},
	{
		id: National.MH,
		value: National.MH,
		label: '마셜 제도',
		labelEnglish: 'MarshallIslands',
	},
	{
		id: National.YT,
		value: National.YT,
		label: '마요티',
		labelEnglish: 'Mayotte',
	},
	{
		id: National.FM,
		value: National.FM,
		label: '마이크로네시아',
		labelEnglish: 'Micronesia',
	},
	{
		id: National.MO,
		value: National.MO,
		label: '마카오',
		labelEnglish: 'MacaoSARChina',
	},
	{
		id: National.MK,
		value: National.MK,
		label: '마케도니아어',
		labelEnglish: 'NorthMacedonia',
	},
	{
		id: National.MW,
		value: National.MW,
		label: '말라위',
		labelEnglish: 'Malawi',
	},
	{
		id: National.MY,
		value: National.MY,
		label: '말레이지아',
		labelEnglish: 'Malaysia',
	},
	{
		id: National.ML,
		value: National.ML,
		label: '말리',
		labelEnglish: 'Mali',
	},
	{
		id: National.MQ,
		value: National.MQ,
		label: '말티니크',
		labelEnglish: 'Martinique',
	},
	{
		id: National.IM,
		value: National.IM,
		label: '맨 섬',
		labelEnglish: 'IsleofMan',
	},
	{
		id: National.MX,
		value: National.MX,
		label: '멕시코',
		labelEnglish: 'Mexico',
	},
	{
		id: National.MC,
		value: National.MC,
		label: '모나코',
		labelEnglish: 'Monaco',
	},
	{
		id: National.MA,
		value: National.MA,
		label: '모로코',
		labelEnglish: 'Morocco',
	},
	{
		id: National.MU,
		value: National.MU,
		label: '모리셔스',
		labelEnglish: 'Mauritius',
	},
	{
		id: National.MR,
		value: National.MR,
		label: '모리타니',
		labelEnglish: 'Mauritania',
	},
	{
		id: National.MZ,
		value: National.MZ,
		label: '모잠비크',
		labelEnglish: 'Mozambique',
	},
	{
		id: National.ME,
		value: National.ME,
		label: '몬테네그로',
		labelEnglish: 'Montenegro',
	},
	{
		id: National.MS,
		value: National.MS,
		label: '몬트세라트',
		labelEnglish: 'Montserrat',
	},
	{
		id: National.MD,
		value: National.MD,
		label: '몰도바',
		labelEnglish: 'Moldova',
	},
	{
		id: National.MV,
		value: National.MV,
		label: '몰디브',
		labelEnglish: 'Maldives',
	},
	{
		id: National.MT,
		value: National.MT,
		label: '몰타',
		labelEnglish: 'Malta',
	},
	{
		id: National.MN,
		value: National.MN,
		label: '몽골',
		labelEnglish: 'Mongolia',
	},
	{
		id: National.US,
		value: National.US,
		label: '미국',
		labelEnglish: 'UnitedStates',
	},
	{
		id: National.UM,
		value: National.UM,
		label: '미국령 군도',
		labelEnglish: 'U.S.OutlyingIslands',
	},
	{
		id: National.VI,
		value: National.VI,
		label: '미국령 버진 아일랜드',
		labelEnglish: 'U.S.VirginIslands',
	},
	{
		id: National.AS,
		value: National.AS,
		label: '미국령 사모아',
		labelEnglish: 'AmericanSamoa',
	},
	{
		id: National.MM,
		value: National.MM,
		label: '미얀마',
		labelEnglish: 'Myanmar(Burma)',
	},
	{
		id: National.VU,
		value: National.VU,
		label: '바누아투',
		labelEnglish: 'Vanuatu',
	},
	{
		id: National.BH,
		value: National.BH,
		label: '바레인',
		labelEnglish: 'Bahrain',
	},
	{
		id: National.BB,
		value: National.BB,
		label: '바베이도스',
		labelEnglish: 'Barbados',
	},
	{
		id: National.VA,
		value: National.VA,
		label: '바티칸',
		labelEnglish: 'VaticanCity',
	},
	{
		id: National.BS,
		value: National.BS,
		label: '바하마',
		labelEnglish: 'Bahamas',
	},
	{
		id: National.BD,
		value: National.BD,
		label: '방글라데시',
		labelEnglish: 'Bangladesh',
	},
	{
		id: National.BM,
		value: National.BM,
		label: '버뮤다',
		labelEnglish: 'Bermuda',
	},
	{
		id: National.VE,
		value: National.VE,
		label: '베네수엘라',
		labelEnglish: 'Venezuela',
	},
	{
		id: National.BJ,
		value: National.BJ,
		label: '베넹',
		labelEnglish: 'Benin',
	},
	{
		id: National.VN,
		value: National.VN,
		label: '베트남',
		labelEnglish: 'Vietnam',
	},
	{
		id: National.BE,
		value: National.BE,
		label: '벨기에',
		labelEnglish: 'Belgium',
	},
	{
		id: National.BY,
		value: National.BY,
		label: '벨라루스',
		labelEnglish: 'Belarus',
	},
	{
		id: National.BZ,
		value: National.BZ,
		label: '벨리즈',
		labelEnglish: 'Belize',
	},
	{
		id: National.BQ,
		value: National.BQ,
		label: '보네르, 신트유스타티우스, 사바 제도',
		labelEnglish: 'CaribbeanNetherlands',
	},
	{
		id: National.BA,
		value: National.BA,
		label: '보스니아 헤르체고비나',
		labelEnglish: 'Bosnia&Herzegovina',
	},
	{
		id: National.BW,
		value: National.BW,
		label: '보츠와나',
		labelEnglish: 'Botswana',
	},
	{
		id: National.BO,
		value: National.BO,
		label: '볼리비아',
		labelEnglish: 'Bolivia',
	},
	{
		id: National.BI,
		value: National.BI,
		label: '부룬디',
		labelEnglish: 'Burundi',
	},
	{
		id: National.BF,
		value: National.BF,
		label: '부르키나파소',
		labelEnglish: 'BurkinaFaso',
	},
	{
		id: National.BV,
		value: National.BV,
		label: '부베이 섬',
		labelEnglish: 'BouvetIsland',
	},
	{
		id: National.BT,
		value: National.BT,
		label: '부탄',
		labelEnglish: 'Bhutan',
	},
	{
		id: National.MP,
		value: National.MP,
		label: '북마리아나 제도',
		labelEnglish: 'NorthernMarianaIslands',
	},
	{
		id: National.KP,
		value: National.KP,
		label: '북한',
		labelEnglish: 'NorthKorea',
	},
	{
		id: National.BG,
		value: National.BG,
		label: '불가리아',
		labelEnglish: 'Bulgaria',
	},
	{
		id: National.BR,
		value: National.BR,
		label: '브라질',
		labelEnglish: 'Brazil',
	},
	{
		id: National.BN,
		value: National.BN,
		label: '브루나이',
		labelEnglish: 'Brunei',
	},
	{
		id: National.WS,
		value: National.WS,
		label: '사모아',
		labelEnglish: 'Samoa',
	},
	{
		id: National.SA,
		value: National.SA,
		label: '사우디아라비아',
		labelEnglish: 'SaudiArabia',
	},
	{
		id: National.GS,
		value: National.GS,
		label: '사우스 조지아 및 사우스 샌드위치 제도',
		labelEnglish: 'SouthGeorgia&SouthSandwichIslands',
	},
	{
		id: National.CY,
		value: National.CY,
		label: '사이프러스',
		labelEnglish: 'Cyprus',
	},
	{
		id: National.SM,
		value: National.SM,
		label: '산마리노',
		labelEnglish: 'SanMarino',
	},
	{
		id: National.ST,
		value: National.ST,
		label: '상투메 프린시페',
		labelEnglish: 'SãoTomé&Príncipe',
	},
	{
		id: National.MF,
		value: National.MF,
		label: '생 마르탱',
		labelEnglish: 'St.Martin',
	},
	{
		id: National.BL,
		value: National.BL,
		label: '생 바르텔레미',
		labelEnglish: 'St.Barthélemy',
	},
	{
		id: National.EH,
		value: National.EH,
		label: '서사하라',
		labelEnglish: 'WesternSahara',
	},
	{
		id: National.SN,
		value: National.SN,
		label: '세네갈',
		labelEnglish: 'Senegal',
	},
	{
		id: National.RS,
		value: National.RS,
		label: '세르비아',
		labelEnglish: 'Serbia',
	},
	{
		id: National.LC,
		value: National.LC,
		label: '세인트 루시아',
		labelEnglish: 'St.Lucia',
	},
	{
		id: National.VC,
		value: National.VC,
		label: '세인트 빈센트 그레나딘스',
		labelEnglish: 'St.Vincent&Grenadines',
	},
	{
		id: National.KN,
		value: National.KN,
		label: '세인트 크리스토퍼 니비스',
		labelEnglish: 'St.Kitts&Nevis',
	},
	{
		id: National.PM,
		value: National.PM,
		label: '세인트 피에르 미켈론',
		labelEnglish: 'St.Pierre&Miquelon',
	},
	{
		id: National.SH,
		value: National.SH,
		label: '세인트 헬레나',
		labelEnglish: 'St.Helena',
	},
	{
		id: National.SO,
		value: National.SO,
		label: '소말리아',
		labelEnglish: 'Somalia',
	},
	{
		id: National.SB,
		value: National.SB,
		label: '솔로몬 제도',
		labelEnglish: 'SolomonIslands',
	},
	{
		id: National.SD,
		value: National.SD,
		label: '수단',
		labelEnglish: 'Sudan',
	},
	{
		id: National.SR,
		value: National.SR,
		label: '수리남',
		labelEnglish: 'Suriname',
	},
	{
		id: National.SC,
		value: National.SC,
		label: '쉐이쉘',
		labelEnglish: 'Seychelles',
	},
	{
		id: National.LK,
		value: National.LK,
		label: '스리랑카',
		labelEnglish: 'SriLanka',
	},
	{
		id: National.SJ,
		value: National.SJ,
		label: '스발바르 및 얀마웬',
		labelEnglish: 'Svalbard&JanMayen',
	},
	{
		id: National.SZ,
		value: National.SZ,
		label: '스와질랜드',
		labelEnglish: 'Eswatini',
	},
	{
		id: National.SE,
		value: National.SE,
		label: '스웨덴',
		labelEnglish: 'Sweden',
	},
	{
		id: National.CH,
		value: National.CH,
		label: '스위스',
		labelEnglish: 'Switzerland',
	},
	{
		id: National.ES,
		value: National.ES,
		label: '스페인',
		labelEnglish: 'Spain',
	},
	{
		id: National.SK,
		value: National.SK,
		label: '슬로바키아',
		labelEnglish: 'Slovakia',
	},
	{
		id: National.SI,
		value: National.SI,
		label: '슬로베니아',
		labelEnglish: 'Slovenia',
	},
	{
		id: National.SY,
		value: National.SY,
		label: '시리아',
		labelEnglish: 'Syria',
	},
	{
		id: National.SL,
		value: National.SL,
		label: '시에라리온',
		labelEnglish: 'SierraLeone',
	},
	{
		id: National.SX,
		value: National.SX,
		label: '신트마르텐(네덜란드령)',
		labelEnglish: 'SintMaarten',
	},
	{
		id: National.SG,
		value: National.SG,
		label: '싱가포르',
		labelEnglish: 'Singapore',
	},
	{
		id: National.AE,
		value: National.AE,
		label: '아랍에미리트',
		labelEnglish: 'UnitedArabEmirates',
	},
	{
		id: National.AW,
		value: National.AW,
		label: '아루바',
		labelEnglish: 'Aruba',
	},
	{
		id: National.AM,
		value: National.AM,
		label: '아르메니아',
		labelEnglish: 'Armenia',
	},
	{
		id: National.AR,
		value: National.AR,
		label: '아르헨티나',
		labelEnglish: 'Argentina',
	},
	{
		id: National.IS,
		value: National.IS,
		label: '아이슬란드',
		labelEnglish: 'Iceland',
	},
	{
		id: National.IE,
		value: National.IE,
		label: '아일랜드',
		labelEnglish: 'Ireland',
	},
	{
		id: National.AZ,
		value: National.AZ,
		label: '아제르바이잔',
		labelEnglish: 'Azerbaijan',
	},
	{
		id: National.AF,
		value: National.AF,
		label: '아프가니스탄',
		labelEnglish: 'Afghanistan',
	},
	{
		id: National.AI,
		value: National.AI,
		label: '안길라',
		labelEnglish: 'Anguilla',
	},
	{
		id: National.AD,
		value: National.AD,
		label: '안도라',
		labelEnglish: 'Andorra',
	},
	{
		id: National.AL,
		value: National.AL,
		label: '알바니아',
		labelEnglish: 'Albania',
	},
	{
		id: National.DZ,
		value: National.DZ,
		label: '알제리',
		labelEnglish: 'Algeria',
	},
	{
		id: National.AO,
		value: National.AO,
		label: '앙골라',
		labelEnglish: 'Angola',
	},
	{
		id: National.AG,
		value: National.AG,
		label: '애티가 바부다',
		labelEnglish: 'Antigua&Barbuda',
	},
	{
		id: National.ER,
		value: National.ER,
		label: '에리트리아',
		labelEnglish: 'Eritrea',
	},
	{
		id: National.EE,
		value: National.EE,
		label: '에스토니아',
		labelEnglish: 'Estonia',
	},
	{
		id: National.EC,
		value: National.EC,
		label: '에쿐아도르',
		labelEnglish: 'Ecuador',
	},
	{
		id: National.SV,
		value: National.SV,
		label: '엘살바도르',
		labelEnglish: 'ElSalvador',
	},
	{
		id: National.GB,
		value: National.GB,
		label: '영국',
		labelEnglish: 'UnitedKingdom',
	},
	{
		id: National.VG,
		value: National.VG,
		label: '영국령 버진 아일랜드',
		labelEnglish: 'BritishVirginIslands',
	},
	{
		id: National.IO,
		value: National.IO,
		label: '영인도 제도',
		labelEnglish: 'BritishIndianOceanTerritory',
	},
	{
		id: National.YE,
		value: National.YE,
		label: '예멘',
		labelEnglish: 'Yemen',
	},
	{
		id: National.OM,
		value: National.OM,
		label: '오만',
		labelEnglish: 'Oman',
	},
	{
		id: National.AU,
		value: National.AU,
		label: '오스트레일리아',
		labelEnglish: 'Australia',
	},
	{
		id: National.AT,
		value: National.AT,
		label: '오스트리아',
		labelEnglish: 'Austria',
	},
	{
		id: National.HN,
		value: National.HN,
		label: '온두라스',
		labelEnglish: 'Honduras',
	},
	{
		id: National.AX,
		value: National.AX,
		label: '올란드 제도',
		labelEnglish: 'ÅlandIslands',
	},
	{
		id: National.JO,
		value: National.JO,
		label: '요르단',
		labelEnglish: 'Jordan',
	},
	{
		id: National.UG,
		value: National.UG,
		label: '우간다',
		labelEnglish: 'Uganda',
	},
	{
		id: National.UY,
		value: National.UY,
		label: '우루과이',
		labelEnglish: 'Uruguay',
	},
	{
		id: National.UZ,
		value: National.UZ,
		label: '우즈베키스탄',
		labelEnglish: 'Uzbekistan',
	},
	{
		id: National.UA,
		value: National.UA,
		label: '우크라이나',
		labelEnglish: 'Ukraine',
	},
	{
		id: National.WF,
		value: National.WF,
		label: '윌리스 푸투나',
		labelEnglish: 'Wallis&Futuna',
	},
	{
		id: National.ET,
		value: National.ET,
		label: '이디예피아',
		labelEnglish: 'Ethiopia',
	},
	{
		id: National.IQ,
		value: National.IQ,
		label: '이라크',
		labelEnglish: 'Iraq',
	},
	{
		id: National.IR,
		value: National.IR,
		label: '이란',
		labelEnglish: 'Iran',
	},
	{
		id: National.IL,
		value: National.IL,
		label: '이스라엘',
		labelEnglish: 'Israel',
	},
	{
		id: National.EG,
		value: National.EG,
		label: '이집트',
		labelEnglish: 'Egypt',
	},
	{
		id: National.IT,
		value: National.IT,
		label: '이탈리아',
		labelEnglish: 'Italy',
	},
	{
		id: National.IN,
		value: National.IN,
		label: '인도',
		labelEnglish: 'India',
	},
	{
		id: National.ID,
		value: National.ID,
		label: '인도네시아',
		labelEnglish: 'Indonesia',
	},
	{
		id: National.JP,
		value: National.JP,
		label: '일본',
		labelEnglish: 'Japan',
	},
	{
		id: National.JM,
		value: National.JM,
		label: '자메이카',
		labelEnglish: 'Jamaica',
	},
	{
		id: National.ZM,
		value: National.ZM,
		label: '잠비아',
		labelEnglish: 'Zambia',
	},
	{
		id: National.JE,
		value: National.JE,
		label: '저지',
		labelEnglish: 'Jersey',
	},
	{
		id: National.GQ,
		value: National.GQ,
		label: '적도 기니',
		labelEnglish: 'EquatorialGuinea',
	},
	{
		id: National.CN,
		value: National.CN,
		label: '중국',
		labelEnglish: 'China',
	},
	{
		id: National.CF,
		value: National.CF,
		label: '중앙 아프리카',
		labelEnglish: 'CentralAfricanRepublic',
	},
	{
		id: National.DJ,
		value: National.DJ,
		label: '지부티',
		labelEnglish: 'Djibouti',
	},
	{
		id: National.GI,
		value: National.GI,
		label: '지브롤터',
		labelEnglish: 'Gibraltar',
	},
	{
		id: National.ZW,
		value: National.ZW,
		label: '짐바브웨',
		labelEnglish: 'Zimbabwe',
	},
	{
		id: National.TD,
		value: National.TD,
		label: '차드',
		labelEnglish: 'Chad',
	},
	{
		id: National.CZ,
		value: National.CZ,
		label: '체코',
		labelEnglish: 'Czechia',
	},
	{
		id: National.CL,
		value: National.CL,
		label: '칠레',
		labelEnglish: 'Chile',
	},
	{
		id: National.CM,
		value: National.CM,
		label: '카메룬',
		labelEnglish: 'Cameroon',
	},
	{
		id: National.KZ,
		value: National.KZ,
		label: '카자흐스탄',
		labelEnglish: 'Kazakhstan',
	},
	{
		id: National.QA,
		value: National.QA,
		label: '카타르',
		labelEnglish: 'Qatar',
	},
	{
		id: National.KH,
		value: National.KH,
		label: '캄보디아',
		labelEnglish: 'Cambodia',
	},
	{
		id: National.CA,
		value: National.CA,
		label: '캐나다',
		labelEnglish: 'Canada',
	},
	{
		id: National.KE,
		value: National.KE,
		label: '케냐',
		labelEnglish: 'Kenya',
	},
	{
		id: National.KY,
		value: National.KY,
		label: '케이마 제도',
		labelEnglish: 'CaymanIslands',
	},
	{
		id: National.KM,
		value: National.KM,
		label: '코모르',
		labelEnglish: 'Comoros',
	},
	{
		id: National.CR,
		value: National.CR,
		label: '코모르',
		labelEnglish: 'CostaRica',
	},
	{
		id: National.CC,
		value: National.CC,
		label: '코코스 군도',
		labelEnglish: 'Cocos(Keeling)Islands',
	},
	{
		id: National.CI,
		value: National.CI,
		label: '코트디부와르',
		labelEnglish: 'Côted’Ivoire',
	},
	{
		id: National.CO,
		value: National.CO,
		label: '콜롯비아',
		labelEnglish: 'Colombia',
	},
	{
		id: National.CG,
		value: National.CG,
		label: '콩고',
		labelEnglish: 'Congo-Brazzaville',
	},
	{
		id: National.CD,
		value: National.CD,
		label: '콩고 민주 공화국',
		labelEnglish: 'Congo-Kinshasa',
	},
	{
		id: National.CU,
		value: National.CU,
		label: '쿠바',
		labelEnglish: 'Cuba',
	},
	{
		id: National.KW,
		value: National.KW,
		label: '쿠웨이트',
		labelEnglish: 'Kuwait',
	},
	{
		id: National.CK,
		value: National.CK,
		label: '쿡 제도',
		labelEnglish: 'CookIslands',
	},
	{
		id: National.CW,
		value: National.CW,
		label: '퀴라소',
		labelEnglish: 'Curaçao',
	},
	{
		id: National.HR,
		value: National.HR,
		label: '크로아티아',
		labelEnglish: 'Croatia',
	},
	{
		id: National.CX,
		value: National.CX,
		label: '크리스마스 섬',
		labelEnglish: 'ChristmasIsland',
	},
	{
		id: National.KG,
		value: National.KG,
		label: '키르기스스탄',
		labelEnglish: 'Kyrgyzstan',
	},
	{
		id: National.KI,
		value: National.KI,
		label: '키리바시',
		labelEnglish: 'Kiribati',
	},
	{
		id: National.TJ,
		value: National.TJ,
		label: '타지키스탄',
		labelEnglish: 'Tajikistan',
	},
	{
		id: National.TZ,
		value: National.TZ,
		label: '탄자니아',
		labelEnglish: 'Tanzania',
	},
	{
		id: National.TH,
		value: National.TH,
		label: '태국',
		labelEnglish: 'Thailand',
	},
	{
		id: National.TC,
		value: National.TC,
		label: '터크스 케이커스 제도',
		labelEnglish: 'Turks&CaicosIslands',
	},
	{
		id: National.TR,
		value: National.TR,
		label: '터키',
		labelEnglish: 'Turkey',
	},
	{
		id: National.TG,
		value: National.TG,
		label: '토고',
		labelEnglish: 'Togo',
	},
	{
		id: National.TK,
		value: National.TK,
		label: '토켈라우',
		labelEnglish: 'Tokelau',
	},
	{
		id: National.TO,
		value: National.TO,
		label: '통가',
		labelEnglish: 'Tonga',
	},
	{
		id: National.TM,
		value: National.TM,
		label: '투르크메니스탄',
		labelEnglish: 'Turkmenistan',
	},
	{
		id: National.TV,
		value: National.TV,
		label: '투발루',
		labelEnglish: 'Tuvalu',
	},
	{
		id: National.TN,
		value: National.TN,
		label: '튀니지',
		labelEnglish: 'Tunisia',
	},
	{
		id: National.TT,
		value: National.TT,
		label: '트리나ד 토바고',
		labelEnglish: 'Trinidad&Tobago',
	},
	{
		id: National.PA,
		value: National.PA,
		label: '파나마',
		labelEnglish: 'Panama',
	},
	{
		id: National.PY,
		value: National.PY,
		label: '파라과이',
		labelEnglish: 'Paraguay',
	},
	{
		id: National.PK,
		value: National.PK,
		label: '파키스탄',
		labelEnglish: 'Pakistan',
	},
	{
		id: National.PG,
		value: National.PG,
		label: '파푸아뉴기니',
		labelEnglish: 'PapuaNewGuinea',
	},
	{
		id: National.PW,
		value: National.PW,
		label: '팔라우',
		labelEnglish: 'Palau',
	},
	{
		id: National.PS,
		value: National.PS,
		label: '팔레스타인',
		labelEnglish: 'PalestinianTerritories',
	},
	{
		id: National.FO,
		value: National.FO,
		label: '페로 제도',
		labelEnglish: 'FaroeIslands',
	},
	{
		id: National.PE,
		value: National.PE,
		label: '페루',
		labelEnglish: 'Peru',
	},
	{
		id: National.PT,
		value: National.PT,
		label: '포르투칼',
		labelEnglish: 'Portugal',
	},
	{
		id: National.FK,
		value: National.FK,
		label: '포클랜드 제도',
		labelEnglish: 'FalklandIslands',
	},
	{
		id: National.PL,
		value: National.PL,
		label: '폴란드',
		labelEnglish: 'Poland',
	},
	{
		id: National.PR,
		value: National.PR,
		label: '푸에르토리코',
		labelEnglish: 'PuertoRico',
	},
	{
		id: National.FR,
		value: National.FR,
		label: '프랑스',
		labelEnglish: 'France',
	},
	{
		id: National.TF,
		value: National.TF,
		label: '프랑스 남부 지방',
		labelEnglish: 'FrenchSouthernTerritories',
	},
	{
		id: National.GF,
		value: National.GF,
		label: '프랑스령 기아나',
		labelEnglish: 'FrenchGuiana',
	},
	{
		id: National.PF,
		value: National.PF,
		label: '프랑스령 폴리네시아',
		labelEnglish: 'FrenchPolynesia',
	},
	{
		id: National.FJ,
		value: National.FJ,
		label: '피지',
		labelEnglish: 'Fiji',
	},
	{
		id: National.FI,
		value: National.FI,
		label: '핀란드',
		labelEnglish: 'Finland',
	},
	{
		id: National.PH,
		value: National.PH,
		label: '필리핀',
		labelEnglish: 'Philippines',
	},
	{
		id: National.PN,
		value: National.PN,
		label: '핏케언 제도',
		labelEnglish: 'PitcairnIslands',
	},
	{
		id: National.HT,
		value: National.HT,
		label: '하이티',
		labelEnglish: 'Haiti',
	},
	{
		id: National.HM,
		value: National.HM,
		label: '허드 섬 및 맥도널드 제도',
		labelEnglish: 'Heard&McDonaldIslands',
	},
	{
		id: National.HU,
		value: National.HU,
		label: '헝가리',
		labelEnglish: 'Hungary',
	},
	{
		id: National.HK,
		value: National.HK,
		label: '홍콩',
		labelEnglish: 'HongKong',
	},
];
